import { render, staticRenderFns } from "./ExistingPhoneNumberVerificationSuccess.vue?vue&type=template&id=3b4d5258&"
import script from "./ExistingPhoneNumberVerificationSuccess.vue?vue&type=script&lang=js&"
export * from "./ExistingPhoneNumberVerificationSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports